module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.woff?893634871a6cbff72157198067c72821";